import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { TransferUploadActions } from '../../../transfer-bundle/store/actions';

import I18n from '@module/i18n';
import Illustration from '@component/illustration';
import Router from '@module/router';
import Actions from '@app/store/action';
import { getIsForwardedTransfer } from '@app/transfer-bundle/store/selectors';

export class Aborted extends React.Component {
  resetTransfer = () => {
    this.props.resetTransfer();
  };

  gotoTransfers() {
    Router.navigateTo('/transfers');
  }

  gotoHelp() {
    Router.navigateTo('/help');
  }

  gotoPayment() {
    Router.navigateTo('/payment/retry');
  }

  doSignout = (event) => {
    const { signout, isForwardedTransfer } = this.props;
    event.preventDefault();
    signout({ isForwardedTransfer });
  };

  componentDidMount() {
    if (
      this.props.transfer.lastError === 'AccountExpired' ||
      this.props.transfer.lastError === 'AccountInactive'
    ) {
      if (!this.node) {
        return;
      }

      const signoutLink = this.node.querySelector('p a');
      if (!signoutLink) {
        return;
      }

      signoutLink['onclick'] = this.doSignout;
    }
  }

  // Let's render our aborted screen (spinner?) and pause buttons.
  render() {
    let button = I18n.t('transfer.buttons.retry');
    let action = this.resetTransfer;
    let title = I18n.t('transfer.failed.title');
    let text = I18n.t('transfer.failed.text');

    switch (this.props.transfer.lastError) {
      case 'LimitReached':
        button = I18n.t('transfer.buttons.cleanup');
        action = this.gotoTransfers;
        title = I18n.t('transfer.storage_full.title');
        text = I18n.t('transfer.storage_full.text_with_limit', {
          storageLimit: I18n.size(this.props.storageLimit, {
            precision: 0,
          }),
        });
        break;

      case 'UserBlocked':
        text = I18n.t('transfer.bubble.errors.blocked');
        button = I18n.t('transfer.buttons.help');
        action = this.gotoHelp;
        break;

      case 'AccountExpired':
        title = I18n.t('transfer.account_expired.title');
        text = I18n.t('transfer.account_expired.text');
        button = I18n.t('transfer.buttons.payment');
        action = this.gotoPayment;
        break;

      case 'AccountInactive':
        title = I18n.t('transfer.account_inactive.title');
        text = I18n.t('transfer.account_inactive.text');
        button = I18n.t('transfer.buttons.complete_order');
        action = this.gotoPayment;
        break;
    }

    return (
      <div
        ref={(node) => (this.node = node)}
        className="transfer__window uploader uploader--error"
      >
        <div className="transfer__contents">
          <Illustration type={'transfer-aborted'} />
          <h2>{title}</h2>
          <p dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        <div className="transfer__footer">
          <button
            className="transfer__button transfer__button--alt"
            onClick={action}
          >
            {button}
          </button>
        </div>
      </div>
    );
  }
}

Aborted.propTypes = {
  resetTransfer: PropTypes.func.isRequired,
  signout: PropTypes.func.isRequired,
  storageLimit: PropTypes.number.isRequired,
  transfer: PropTypes.object,
  isForwardedTransfer: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isForwardedTransfer: getIsForwardedTransfer(state),
});

const mapDispatchToProps = {
  resetTransfer: TransferUploadActions.resetTransfer,
  signout: Actions.User.signout.bind(Actions.User),
};

export default connect(mapStateToProps, mapDispatchToProps)(Aborted);
